import React from "react";
import CustomSelectEdit from "../customEdits/CustomSelectEdit";
import { Select } from "components/select/index";
import CustomInputEdit from "../customEdits/CustomInputEdit";
import Input from "components/form/input/Input";
import CustomCheckboxEdit from "../customEdits/CustomCheckboxEdit";
import Checkbox from "components/form/checkbox/Checkbox";
import CustomTextEdit from "../customEdits/CustomTextEdit";
import TextField from "components/form/textField/TextField";
import { useFormEditContext } from "../FormEditContext";
import DraggableEditInput from "components/draggableEditInput/DraggableEditInput";
import { useTranslation } from "react-i18next";
import { FormInput, FormInputTypeAssignedAttribute } from "redux/reducers/models/formInput";

interface IFormEditInputProps {
  formInput: FormInput;
}

interface IInputAssignedAttributeOption {
  id: FormInputTypeAssignedAttribute;
  label: string;
}

export default function FormEditInput(props: IFormEditInputProps) {
  const { Option } = Select;

  const { formInput } = props;

  const formEditContext = useFormEditContext();
  const { t, i18n } = useTranslation();

  const inputAssignedAttributeOptions: IInputAssignedAttributeOption[] = [
    { id: "users_first_name", label: t("Customer First Name") },
    { id: "users_last_name", label: t("Customer Last Name") },
    { id: "users_email", label: t("Customer Email") },
    { id: "users_phone", label: t("Customer Phone") },
  ];

  return (
    <DraggableEditInput
      item={formInput}
      rows={formEditContext.formInputRowsContainer?.updatedState}
      setSelectedEditInput={formEditContext.setSelectedFormInput}
    >
      {formInput.type === "select" && (
        <CustomSelectEdit
          label={formInput.label}
          helpText={formInput.help_text}
          array={formInput.values}
          required={formInput.required}
          saveInput={(label, values, helpText, required) =>
            formEditContext.handleUpdateInput("select", formInput.id, label, helpText, values, null, required)
          }
          editModalOpen={
            formEditContext.selectedFormInput.id === formInput.id && formEditContext.selectedFormInput.editModalOpen
          }
          closeEditModal={formEditContext.closeFormInputEditModal}
        >
          <Select label={formInput.label} helpText={formInput.help_text}>
            {!formInput.values || formInput?.values?.length < 1 ? (
              <Option key={"empty"} value={""}></Option>
            ) : (
              <>
                {formInput.values.map((value: string, index) => (
                  <Option key={index} value={value}>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "18px",
                      }}
                    >
                      {value}
                    </span>
                  </Option>
                ))}
              </>
            )}
          </Select>
        </CustomSelectEdit>
      )}

      {formInput.type === "input" && (
        <CustomInputEdit
          label={formInput.label}
          helpText={formInput.help_text}
          required={formInput.required}
          assignedAttribute={formInput.assigned_attribute}
          assignedAttributeOptions={inputAssignedAttributeOptions}
          saveInput={(label, value, helpText, assignedAttribute, required) =>
            formEditContext.handleUpdateInput("input", formInput.id, label, helpText, null, assignedAttribute, required)
          }
          editModalOpen={
            formEditContext.selectedFormInput.id === formInput.id && formEditContext.selectedFormInput.editModalOpen
          }
          closeEditModal={formEditContext.closeFormInputEditModal}
        >
          <Input
            id={formInput.id}
            label={formInput.label}
            helpText={formInput.help_text}
            defaultValue={formInput.values}
            readOnly
          />
        </CustomInputEdit>
      )}

      {formInput.type === "checkbox" && (
        <CustomCheckboxEdit
          label={formInput.label}
          helpText={formInput.help_text}
          required={formInput.required}
          options={formInput.values}
          saveInput={(label, helpText, required) =>
            formEditContext.handleUpdateInput("checkbox", formInput.id, label, helpText, null, null, required)
          }
          editModalOpen={
            formEditContext.selectedFormInput.id === formInput.id && formEditContext.selectedFormInput.editModalOpen
          }
          closeEditModal={formEditContext.closeFormInputEditModal}
        >
          <Checkbox size="medium" label={formInput.label} supportText={formInput.help_text} checked={false} readOnly />
        </CustomCheckboxEdit>
      )}

      {formInput.type === "text" && (
        <CustomTextEdit
          label={formInput.label}
          description={formInput.help_text}
          saveInput={(label: string, description: string) =>
            formEditContext.handleUpdateInput("text", formInput.id, label, description, null, null)
          }
          editModalOpen={
            formEditContext.selectedFormInput.id === formInput.id && formEditContext.selectedFormInput.editModalOpen
          }
          closeEditModal={formEditContext.closeFormInputEditModal}
        >
          <TextField label={formInput.label} value={formInput.help_text} readOnly />
        </CustomTextEdit>
      )}
    </DraggableEditInput>
  );
}
